<template>
  <b-container>
    <div class="text-center mt-4">
      <b-button
        @click="showCode = !showCode"
      >
        {{ showCode ? 'Hide' : 'Show' }} code
      </b-button>
    </div>
    <iframe
      ref="notebook"
      :srcdoc="showCode ? htmlCodeStyled : htmlNoCodeStyled"
      width="100%"
      style="height:200px;width:100%;border:none;overflow:hidden;"
      onload="this.style.height=(this.contentWindow.document.body.scrollHeight+20)+'px';"
      @load="notebookLoaded"
    />
  </b-container>
</template>

<script>
import htmlCode from './html/demography.html';
import htmlNoCode from './html/demography_nocode.html';
import notebookCSS from '@/js/notebook_css';

export default {
  name: 'demography.vue',
  data() {
    return {
      showCode: false,
      noCodeHeight: null,
      showCodeHeight: null,
    };
  },
  computed: {
    htmlCodeStyled() {
      return htmlCode.replace('</head>', `<style>${notebookCSS}</style></head>`);
    },
    htmlNoCodeStyled() {
      const out = htmlNoCode.replace('</head>', `<style>${notebookCSS}</style></head>`);
      return out;
    },
  },

  methods: {
    notebookLoaded() {
      const { notebook } = this.$refs;
      if (this.showCode && this.showCodeHeight === null) {
        this.showCodeHeight = `${notebook.contentWindow.document.body.scrollHeight + 80}px`;
      }
      if (!this.showCode && this.noCodeHeight === null) {
        this.noCodeHeight = `${notebook.contentWindow.document.body.scrollHeight + 80}px`;
      }
      notebook.style.height = this.showCode ? this.showCodeHeight : this.noCodeHeight;
    },
  },
};
</script>
